import React from "react";
import kosmos from "../assets/kosmos.png";
import "../index.css";
import { useNavigate } from "react-router-dom";
import HalfCircle from '../assets/HalfCirce.png'

export const BookSlot = () => {
   const navigate = useNavigate();

  const handleSubmit = () => {
    navigate("/slotpage");
  };
  return (
<div className="relative w-full  bg-[#0C0C0C] flex items-center justify-center overflow-hidden">
  <img
    src={HalfCircle}
    alt="Circle"
    className="absolute top-0  w-full h-auto z-0 pointer-events-none select-none"
  />

  <div className="relative z-10 flex flex-col items-center text-center px-4">
    
    <div className="mb-3 mt-8 md:mt-16 lg:mt-24 xl:mt-44 2xl:mt-64">
      <img src={kosmos} alt="Kosmos Logo" className="w-20 md:w-24 lg:w-28" />
    </div>
    <p className="text-white font-langit text-[24px] md:text-[48px] lg:text-[72px] leading-tight tracking-wide">
      Lets start<br />your Booking
    </p>
    <p className="text-white/60 text-[10px] md:text-base lg:text-lg mt-4 mb-6 font-intertight">
      Reserve Your Badminton Court Instantly and Get Ready to<br />
      Play Without the Wait!
    </p>
    <button
      onClick={handleSubmit}
      className="font-league tracking-wider cursor-pointer border-none bg-[#F58220] text-white py-3 px-8 text-sm md:text-lg transition duration-300 hover:bg-[#e37110] rounded-sm mb-4"
    >
      BOOK YOUR SLOT
    </button>
  </div>
</div>


  );
};
